"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _videoText = _interopRequireDefault(require("../../../videoText"));
var _utils = require("../../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const MenuContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "VideoMenu__MenuContainer",
  componentId: "components-web__sc-nllbhw-0"
})(_ref => {
  let {
    padding,
    background
  } = _ref;
  return {
    width: 114,
    padding,
    backgroundColor: background,
    borderRadius: 5
  };
});
const MenuButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "VideoMenu__MenuButton",
  componentId: "components-web__sc-nllbhw-1"
})({
  background: 'none',
  border: 'none',
  padding: 0,
  width: '100%',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  verticalAlign: 'middle'
});
const CheckmarkContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "VideoMenu__CheckmarkContainer",
  componentId: "components-web__sc-nllbhw-2"
})(_ref2 => {
  let {
    isSelectedItem,
    checkMarkWidth,
    checkMarkHeight,
    checkMarkSelectedColor,
    checkMarkHoverColor,
    checkMarkFocusColor,
    checkMarkUnselectedColor
  } = _ref2;
  return {
    width: checkMarkWidth,
    height: checkMarkHeight,
    marginTop: 2,
    outline: 'none',
    [`${MenuButton} && svg`]: {
      fill: isSelectedItem ? checkMarkSelectedColor : checkMarkUnselectedColor
    },
    [`${MenuButton}:hover && svg`]: {
      fill: isSelectedItem ? checkMarkSelectedColor : checkMarkHoverColor
    },
    [`${MenuButton}:focus && svg`]: {
      fill: isSelectedItem ? checkMarkSelectedColor : checkMarkFocusColor
    }
  };
});
const VideoMenu = _ref3 => {
  let {
    menuLabel,
    menuOptions,
    setSelection,
    selectedItem,
    copy,
    tokens,
    variant,
    ...rest
  } = _ref3;
  const {
    padding,
    background,
    checkMarkWidth,
    checkMarkHeight,
    checkMarkSelectedColor,
    checkMarkHoverColor,
    checkMarkFocusColor,
    checkMarkUnselectedColor,
    checkMarkIcon
  } = (0, _componentsBase.useThemeTokens)('VideoMenu', tokens, variant);
  const getMenuItems = () => {
    return menuOptions.map(option => {
      if (option.name) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MenuButton, {
          "aria-haspopup": "true",
          role: "menuitem",
          "aria-label": `${option.name} ${menuLabel}. ${selectedItem === option.value ? _videoText.default[copy].itemSelected : _videoText.default[copy].itemUnselected}`,
          selectedItem: selectedItem,
          itemValue: option.value,
          onClick: () => {
            if (selectedItem !== option.value) {
              setSelection(option.value);
            }
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
            variant: {
              bold: true,
              inverse: true
            },
            children: option.name
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckmarkContainer, {
            isSelectedItem: option.value === selectedItem,
            checkMarkWidth: checkMarkWidth,
            checkMarkHeight: checkMarkHeight,
            checkMarkSelectedColor: checkMarkSelectedColor,
            checkMarkHoverColor: checkMarkHoverColor,
            checkMarkFocusColor: checkMarkFocusColor,
            checkMarkUnselectedColor: checkMarkUnselectedColor,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Icon, {
              icon: checkMarkIcon
            })
          })]
        }, option.value);
      }
      return null;
    });
  };
  const handleOnKeyDown = event => {
    const key = event.key || event.keyCode;

    // Disables playing by space bar, as that can be used to click a button
    if (key === ' ' || key === 32) {
      event.stopPropagation();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuContainer, {
    onKeyDown: handleOnKeyDown,
    padding: padding,
    background: background,
    ...selectProps(rest),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.StackView, {
      space: 2,
      divider: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
        variant: {
          bold: true,
          inverse: true
        },
        children: menuLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        role: "menu",
        children: getMenuItems()
      })]
    })
  });
};
VideoMenu.propTypes = {
  ...selectedSystemPropTypes,
  menuLabel: _propTypes.default.string.isRequired,
  menuOptions: _propTypes.default.array.isRequired,
  setSelection: _propTypes.default.func.isRequired,
  selectedItem: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  copy: _propTypes.default.oneOf(['en', 'fr']).isRequired
};
var _default = exports.default = VideoMenu;